import {IExportStyles,} from "@ui/tableCustom/types/columns";
import {
    IExportExcelStylesAlignment,
    IExportExcelStylesBorders,
    IExportExcelStylesFill,
    IExportExcelStylesFont
} from "@containers/export/containers/excel/types";

export const BASE_EXCEL_FILL_COLOR = '#e6e6e6'
export const BASE_EXCEL_STYLES_BORDERS: IExportExcelStylesBorders = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    right: {
        style: 'thin',
    },
    bottom: {
        style: 'thin',
    },
}

export const BASE_EXCEL_STYLES_ALIGNMENT: IExportExcelStylesAlignment = {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true,
}

export const BASE_EXCEL_STYLES_FILL: IExportExcelStylesFill = {
    fgColor: {
        rgb: BASE_EXCEL_FILL_COLOR
    },
}

export const BASE_EXCEL_STYLES_FONT: IExportExcelStylesFont = {
    sz: '10',
}

export const BASE_EXPORT_STYLES: IExportStyles = {
    excel: {
        width: {
            wch: 25,
        },
        font: {
            sz: '10',
        },
        border: BASE_EXCEL_STYLES_BORDERS,
    },
    pdf: {
        width: 65
    }
}

export const BASE_EXPORT_HEADER_STYLES: IExportStyles = {
    excel: {
        border: BASE_EXCEL_STYLES_BORDERS,
        alignment: BASE_EXCEL_STYLES_ALIGNMENT,
        font: BASE_EXCEL_STYLES_FONT,
        fill: BASE_EXCEL_STYLES_FILL
    },
    pdf: {
        width: 55
    }
}